<template>
  <div class="filters" :class="{ active: active, open: drawerOpen }">
    <h2>Filter By<span>{{ events.length }} results</span></h2>

    <div class="filters-content">
      <div class="filter-group">
        <h3>Event Type</h3>
        <div class="filters-list">
          <button class="filter" @click="filterByEventType('Studio Visit')" :class="{ active: selectedEventType.indexOf('Studio Visit') > -1 }">Studio Visit</button>
          <button class="filter" @click="filterByEventType('Artist Talk')" :class="{ active: selectedEventType.indexOf('Artist Talk') > -1 }">Artist Talk</button>
          <button class="filter" @click="filterByEventType('Workshop')" :class="{ active: selectedEventType.indexOf('Workshop') > -1 }">Workshop</button>
          <button class="filter" @click="filterByEventType('Demonstration')" :class="{ active: selectedEventType.indexOf('Demonstration') > -1 }">Demonstration</button>
          <button class="filter" @click="filterByEventType('Performance')" :class="{ active: selectedEventType.indexOf('Performance') > -1 }">Performance</button>
          <button class="filter" @click="filterByEventType('Panel Discussion')" :class="{ active: selectedEventType.indexOf('Panel Discussion') > -1 }">Panel Discussion</button>
          <button class="filter" @click="filterByEventType('Guided Tour')" :class="{ active: selectedEventType.indexOf('Guided Tour') > -1 }">Guided Tour</button>
        </div>
      </div>
    </div>

    <button class="btn" v-on:click="closeDrawer">Close</button>
  </div>
</template>

<script>
export default {
  props: ["events", "selectedEventType"],
  data() {
    return {
      active: false,
      activeTimeout: null,
      drawerOpen: false,
    }
  },
  methods: {
    filterUpdate() {
      this.$parent.filtersChanged();
    },
    filterByEventType(by) {
      if (this.$parent.selectedEventType.indexOf(by) > -1) {
        this.$parent.selectedEventType.splice(this.$parent.selectedEventType.indexOf(by), 1);
      } else {
        this.$parent.selectedEventType.push(by);
      }

      this.filterUpdate();
    },
    openDrawer() {
      clearTimeout(this.activeTimeout);
      this.active = true;
      document.body.classList.add('stop-scroll');
      setTimeout(() => {
        this.drawerOpen = true;
      }, 50);
    },
    closeDrawer() {
      this.drawerOpen = false;
      document.body.classList.remove('stop-scroll');
      this.activeTimeout = setTimeout(() => {
        this.active = false;
      }, 500);
    },
  },
};
</script>

<style src="../css/Filters.less" scoped lang="less"></style>



// WEBPACK FOOTER //
// src/components/EventsFilters.vue